import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut, User } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/lib/auth-context';

export function Header(): JSX.Element {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  async function handleLogout(): Promise<void> {
    await logout();
    navigate('/login');
  }

  return (
    <header className="flex h-14 items-center justify-between border-b bg-background px-4">
      <h1 className="text-lg font-semibold">Version Mgmt Dashboard</h1>
      <div className="relative">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => setOpen((o) => !o)}
          className="flex items-center gap-2"
        >
          <User className="h-4 w-4" />
          <span className="hidden sm:inline">{user?.email}</span>
          <span className="hidden sm:inline text-xs text-muted-foreground">({user?.role})</span>
        </Button>
        {open && (
          <div className="absolute right-0 mt-1 w-48 rounded-md border bg-popover p-1 shadow-md z-10">
            <button
              onClick={handleLogout}
              className="flex w-full items-center gap-2 rounded-sm px-2 py-1.5 text-sm hover:bg-accent"
            >
              <LogOut className="h-4 w-4" />
              Logout
            </button>
          </div>
        )}
      </div>
    </header>
  );
}
